import { REPORT_TYPES } from '@repo/constants'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/reports/operations')({
  staticData: {
    title: REPORT_TYPES.OPERATIONS,
    crumb: REPORT_TYPES.OPERATIONS,
    permissions: ['reports_view_operations'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
